import call from './httpClient';

const BASE_URL = `${import.meta.env.VITE_APP_API_URL}/v1/products`;

// eslint-disable-next-line import/prefer-default-export
export const Get = async () => call({
  url: BASE_URL,
  method: 'GET',
});

const RECOMMENDATIONS_URL = `${import.meta.env.VITE_APP_API_URL}/v1/product-recommendations`;

export const GetProductRecommendations = async () => call({
  url: RECOMMENDATIONS_URL,
  method: 'GET',
});
